import React, { useMemo } from 'react'
import type { InboxConversationSummary } from './inboxTypes'
import { ConversationSummaryIcon } from './ConversationSummaryIcon'
import { displayAuthorName, joinParticipantNames, truncate } from './utils'

interface ConversationSummaryItemProps {
  conversation: InboxConversationSummary
  isSelected: boolean
  onClick: () => void
}

export const ConversationSummaryItem: React.FC<ConversationSummaryItemProps> = ({
  conversation,
  isSelected,
  onClick
}) => {
  const showUnread = conversation.unreadMessages && !isSelected
  const participants = conversation.participants

  const displayName = useMemo(() => joinParticipantNames(participants), [participants])

  const snippet = truncate(conversation.lastMessageText ?? '', 50)
  const authorLabel = displayAuthorName(
    conversation.lastMessageSenderName,
    conversation.lastMessageSenderIsCurrentUser
  )

  return (
    <button
      type='button'
      className={[
        'conversation-list-item',
        isSelected ? 'is-selected' : '',
        showUnread ? 'is-unread' : ''
      ].join(' ').trim()}
      onClick={onClick}
    >
      <ConversationSummaryIcon
        conversationType={conversation.conversationType}
        participants={participants}
      />

      <div className='conversation-list-content'>
        <div className='conversation-list-top-row'>
          <h3 className='conversation-list-name'>
            {displayName}
          </h3>

          {showUnread && (
            <span className='inbox-unread-dot' aria-label='Unread' />
          )}
        </div>

        <div className='conversation-list-summary'>
          {authorLabel}
          <span>: </span>
          <span>{snippet}</span>
        </div>
      </div>
    </button>
  )
}
